var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.domicilios,"headers":_vm.headers,"items-per-page":100,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.piso",fn:function({item}){return [_vm._v(" "+_vm._s(item.piso)+_vm._s(item.depto)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }